// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__tQn-J","header":"styles_header__nbQkc"};